import type { WellKnown } from "@/types/well-known";
import { useQuery } from "@tanstack/react-query";

export function useApplyTheme() {
  return useQuery<WellKnown>({
    queryKey: ["well-known"],
    queryFn: () => (globalThis as any)._appSettings as Promise<WellKnown>,
    staleTime: Infinity,
    select(data) {
      if (!data.primary_color || !data.secondary_color || !data.accent_color) {
        console.warn(
          "One or more theme colors are missing in the well-known data. Using default colors.",
        );
        return data;
      }

      const root = document.documentElement;
      root.style.setProperty("--color-primary", data.primary_color);
      root.style.setProperty("--color-secondary", data.secondary_color);
      root.style.setProperty("--color-accent", data.accent_color);

      if (data.favicon) {
        let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = data.favicon;
      }

      return data;
    },
  });
}
